<div class="d-flex align-items-center">
  <div>{{ value() }}</div>
  @if (hasNewerFirmware()) {
    @if (hasWrite()) {
      <mat-icon
        class="green pl-6 firmware-icon"
        matTooltip="Firmware update available"
        (click)="firmwareUpgrade.emit($event)"
        >arrow_circle_up
      </mat-icon>
    } @else {
      <mat-icon
        class="disabled pl-6 firmware-icon"
        matTooltip="You do not have permission to update firmware"
        >arrow_circle_up
      </mat-icon>
    }
  }
</div>
